import { Typography, IconButton } from "@mui/material";
import { IconCopy } from "src/components/icons-mui/copy";
import { CopyIsinDialog } from "src/components/modals/copy-isin-dialog/copy-isin-dialog";
import { GTM_COPY_ISIN_BUTTON } from "src/consts/gtm";
import { useCopyIsin } from "src/hooks/use-copy-isin";
import { useCertificateBoxContext } from "../context";

export const CBIsin = () => {
    const { dict, data, selectedCertificate: certificate } = useCertificateBoxContext();
    const isin = certificate.isin;

    const { copyIsin } = useCopyIsin({ isin });

    return (
        <CopyIsinDialog wikifolioId={data.wikifolio.id} wikifolioShortDescription={data.wikifolio.shortDescription}>
            {openDialog => (
                <IconButton
                    sx={{ width: "100%", justifyContent: "left", p: 1 }}
                    variant="outlined"
                    size="small"
                    aria-label={dict.copy}
                    onClick={event => {
                        openDialog();
                        copyIsin(event);
                    }}
                    className={GTM_COPY_ISIN_BUTTON}
                >
                    <>
                        <Typography fontWeight="bold" sx={{ pr: 0.5 }}>
                            {dict.isin}
                        </Typography>
                        <Typography id="isin-value" component="strong">
                            {isin}
                        </Typography>
                        <IconCopy sx={{ width: "24px", height: "24px", marginLeft: "auto" }} />
                    </>
                </IconButton>
            )}
        </CopyIsinDialog>
    );
};
